<template>
  <v-card>
    <div class="d-flex flex-row flex-nowrap pa-5">
      <div class="flex-grow-1 d-flex flex-row align-end">
        <div class="mr-1">
          <Datepicker
            label="Start Date"
            hide-details
            :value="startDate"
            :onChange="handleStartChange"
          />
        </div>
        <div class="mr-2 ml-1">
          <Datepicker
            label="End Date"
            hide-details
            :value="endDate"
            :onChange="handleEndChange"
          />
        </div>
      </div>
      <div class="d-flex flex-row">
        <v-card
          flat
          outlined=""
          height="100"
          class="d-flex pa-5 mr-1 align-center justify-center"
        >
          <div class="d-flex align-start">
            <h1 class="purple--text mr-2 text-h1" style="line-height: 1">
              {{ regularCustomers }}
            </h1>
            <h3 class="text-h5 mt-2">Regular Customers</h3>
          </div>
        </v-card>
        <v-card
          flat
          outlined=""
          height="100"
          class="d-flex pa-5 ml-1 align-center justify-center"
        >
          <div class="d-flex align-start">
            <h3 class="orange--text mr-2 text-h1" style="line-height: 1">
              {{ newCustomers }}
            </h3>
            <h3 class="text-h5 mt-2">New Customers</h3>
          </div>
        </v-card>
      </div>
    </div>
    <section>
      <v-row>
        <v-col cols="12" md="6">
          <Barchart
            :labels="areaReport.labels"
            :datasets="areaReport.datasets"
            :height="300"
          />
        </v-col>
        <v-col cols="12" md="6">
          <Barchart
            :labels="dayReport.labels"
            :datasets="dayReport.datasets"
            :height="300"
          />
        </v-col>
      </v-row>
    </section>
    <v-data-table
      :headers="headers"
      :items="list"
      :loading="loading"
      :server-items-length="totalItems"
      :options.sync="options"
    >
      <template v-slot:item.cuscount="{ item }">
        <v-chip color="purple--text" outlined v-if="item.cuscount > 1">
          Regular Customer
        </v-chip>
        <v-chip color="orange--text" outlined v-if="item.cuscount === 1">
          New Customer
        </v-chip>
      </template>
      <template v-slot:item.action="{ item }">
        <v-btn text :to="`customers/view/${item.customerid}`" class="mr-1">
          View Customer
        </v-btn>
        <v-btn text :to="`sales/edit/${item.id}`"> View Sale </v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { report } from "@/api";
import Datepicker from "../Datepicker";
import moment from "moment";
import Storage from "@/utils/storage";
import Barchart from "../Charts/Barchart.vue";

export default {
  name: "Dashboard",
  components: {
    Datepicker,
    Barchart,
  },
  data: () => ({
    startDate: null,
    endDate: null,
    totalItems: 0,
    loading: false,
    options: {},
    headers: [
      { text: "Sale", value: "id" },
      { text: "Date", value: "date" },
      { text: "Customer ID", value: "customerid" },
      { text: "Customer Type", value: "cuscount" },
      { text: "Location", value: "location" },
      { text: "Actions", value: "action", sortable: false },
    ],
    list: [],
    regularCustomers: 0,
    newCustomers: 0,
    areaReport: {
      labels: [],
      datasets: [],
    },
    dayReport: {
      labels: [],
      datasets: [],
    },
  }),
  watch: {
    options: {
      handler() {
        this.getItems();
      },
      deep: true,
    },
  },
  methods: {
    initialize() {
      this.getItems();
    },
    async getItems() {
      if (this.startDate) {
        const { page = 0, itemsPerPage = 10 } = this.options;
        this.loading = true;
        const range = {
          start: this.startDate,
          end: this.endDate,
        };
        let customerReport = report.getCustomerReport(
          itemsPerPage,
          page,
          range
        );
        let areaReport = report.getAreaReport(range);
        let dayReport = report.getDayReport(range);
        customerReport = await customerReport;
        areaReport = await areaReport;
        dayReport = await dayReport;

        this.totalItems = customerReport.data.total;
        this.list = customerReport.data.list;
        this.regularCustomers = customerReport.data.regularcustomers;
        this.newCustomers = customerReport.data.newcustomers;
        this.setAreaData(areaReport.data);
        this.setDaysData(dayReport.data);
        this.loading = false;
      }
    },
    setAreaData(data) {
      const labels = [];
      const barData = [];

      data.forEach((d) => {
        labels.push(d.city);
        barData.push(d.total);
      });
      this.areaReport.labels = labels;
      this.areaReport.datasets = [
        {
          label: "Area Sales",
          backgroundColor: "#f87979",
          data: barData,
        },
      ];
    },
    setDaysData(data) {
      const labels = [];
      const barData = [];

      data.forEach((d) => {
        labels.push(d.day);
        barData.push(d.total);
      });
      this.dayReport.labels = labels;
      this.dayReport.datasets = [
        {
          label: "Day sale",
          backgroundColor: "#51bfb5",
          data: barData,
        },
      ];
    },
    handleStartChange(value) {
      Storage.set("startDate", value);
      this.startDate = value;
      this.getItems();
    },
    handleEndChange(value) {
      Storage.set("endDate", value);
      this.endDate = value;
      this.getItems();
    },
  },
  mounted() {
    let startDate = Storage.get("startDate");
    let endDate = Storage.get("endDate");
    if (!startDate) startDate = new Date();
    if (!endDate) endDate = new Date();
    this.startDate = moment(startDate).startOf("month").format("YYYY-MM-DD");
    this.endDate = moment(endDate).endOf("month").format("YYYY-MM-DD");
  },
};
</script>

<style>
</style>